import React, { Component } from 'react';
import { Card, message } from 'antd';
import Process from '@comm/workflow/Process';
import ProcessHistory from '@comm/workflow/ProcessHistory';
import { browserHistory } from 'react-router';
import Modalshortfalls from '@comm/shortfalls';

import { queryDeleteLoan, queryLoanWorkflow, querySaveLoan } from '@api/finance/loan';
import FormBase from './FormBase';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      isSubmitting: false,
      instance: {
        activities: [],
        currentActivity: {},
      },
      shortData: '',
      visible: false,
    };
  }

  componentDidMount() {
    const { dataInfo } = this.state;
    this.setState({ dataInfo });
    this.loanWorkflow();
  }

  /**
   * 提交借款
   */
  handSubmit = item => {
    this.saveLoan(item);
  };

  loanWorkflow = params => {
    const { instance } = this.state;
    queryLoanWorkflow(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          instance: {
            ...instance,
            activities: res.data,
          },
        });
      }
    });
  };

  /**
   * 保存
   */
  saveLoan = item => {
    this.setState({
      isSubmitting: true,
    });
    querySaveLoan(item).then(res => {
      this.setState({
        isSubmitting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else if (res.message.indexOf('\n') === -1) {
        message.error(res.message);
      } else {
        this.setState({
          shortData: res.message,
          visible: true,
        });
      }
    });
  };

  hideModal = () => {
    this.setState({
      visible: false,
    });
  };

  deleteLoan = () => {
    queryDeleteLoan({
      uuid: this.props.data.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { isSubmitting, instance, shortData, visible } = this.state;
    const dataInfo = this.props.data;
    const histories = dataInfo.histories || [];
    return (
      <div>
        <FormBase
          data={this.props.data}
          handSubmit={this.handSubmit}
          handleDelete={this.deleteLoan}
          isSubmitting={isSubmitting}
          {...this.props}
        />
        <Card>
          <Process instance={instance} />
          <div style={{ marginTop: '16px' }}>
            <ProcessHistory dataSource={histories} />
          </div>
        </Card>
        <Modalshortfalls data={shortData || ''} visible={visible} hideModal={this.hideModal} />
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/finance/loan/PageEdit.js